import * as info from "info";
import * as ewe from "@eyeo/webext-ad-filtering-solution";
import { getUserId } from "../../../adblock-betafish/id/background/index";
import { License } from "../../../adblock-betafish/picreplacement/check";
import { Prefs } from "../../../adblock-betafish/alias/prefs";
export async function getInjectionInfo() {
    await Promise.all([Prefs.untilLoaded, License.ready()]);
    const [isPremium, id, experimentFlags, isTrial, er, ev, ca] = await Promise.all([
        License.isActiveLicense(),
        getUserId(),
        ewe.experiments.getFlags(),
        ewe.account.isTrial(),
        ewe.remoteConfig.getRevisionId(),
        ewe.experiments.getEncodedExperiments(),
        ewe.cohorts.getEncodedCohorts(),
    ]);
    const version = info.addonVersion;
    const blockCount = Prefs.get("blocked_total");
    const installDate = Prefs.get("installDate");
    return { isPremium, isTrial, version, id, blockCount, installDate, experimentFlags, er, ev, ca };
}
